import { render, staticRenderFns } from "./RiskKontrolAdd.vue?vue&type=template&id=4b548ccb"
import script from "./RiskKontrolAdd.vue?vue&type=script&lang=js"
export * from "./RiskKontrolAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports